import {
  alternateOgLocaleForLocale,
  languageForLocale,
  localizedUrl,
  ogLocaleForLocale
} from '@/utils/seoUrls'

const SITE_URL = 'https://www.bullverge.it'
export const DEFAULT_OG_IMAGE = `${SITE_URL}/scred.jpg`

export function buildPageHead({
  title,
  description,
  path,
  locale,
  imageAlt,
  type = 'website',
  schema,
  schemaKey = 'page-schema'
}) {
  const pageUrl = localizedUrl(path, locale)

  const head = {
    title,
    meta: [
      { name: 'description', content: description },
      { name: 'robots', content: 'index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1' },
      { property: 'og:title', content: title },
      { property: 'og:description', content: description },
      { property: 'og:url', content: pageUrl },
      { property: 'og:type', content: type },
      { property: 'og:locale', content: ogLocaleForLocale(locale) },
      { property: 'og:locale:alternate', content: alternateOgLocaleForLocale(locale) },
      { property: 'og:image', content: DEFAULT_OG_IMAGE },
      { property: 'og:image:alt', content: imageAlt || title },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: title },
      { name: 'twitter:description', content: description },
      { name: 'twitter:image', content: DEFAULT_OG_IMAGE },
      { name: 'twitter:image:alt', content: imageAlt || title }
    ]
  }

  if (schema) {
    head.script = [
      {
        key: schemaKey,
        type: 'application/ld+json',
        children: JSON.stringify({
          inLanguage: languageForLocale(locale),
          ...schema,
          url: schema.url || pageUrl
        })
      }
    ]
  }

  return head
}
